/// <reference path="../../../../Frontend.Core/dist/definitions/models/CC.Library.d.ts" />
/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.d.ts" />
/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.Calendar.d.ts" />
/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.DateUtils.d.ts" />

import * as React from "react";
import {Datepicker} from "./datepicker";

export interface IDatepickerDayProps {
    date: Date,
    label: string,
    toggleCallback: any,
    isToggled: boolean,
    isCheckout: boolean,
    userToggledDate: boolean,
    isDisabled?: boolean,
    showYear: boolean
}

export interface IDatepickerDayState {
    isDirty: boolean
}

export class DatepickerDay extends React.Component<IDatepickerDayProps, IDatepickerDayState> {
    
    constructor(props: IDatepickerDayProps) {
        super(props);

        this.props = props;

        this.state = {
            isDirty: true // TODO: Remove this after 1.7.4
        };
    }

    componentWillReceiveProps (nextProps: IDatepickerDayProps) {
        if (nextProps.date == null)
            return;

        let compTime: number = this.props.date == null ? null : this.props.date.getTime();

        if (nextProps.userToggledDate !== this.props.userToggledDate)
            this.setState({ isDirty: nextProps.userToggledDate});

        if (nextProps.date.getTime() !== compTime || nextProps.label !== this.props.label)
            this.forceUpdate();
    }

    handleClick = (e: any) => {
        if (this.props.isDisabled)
            return;

        this.props.toggleCallback(!this.props.isToggled);

        this.setState({
            isDirty: true
        });
    }

    render() {

        if (this.props.date == null)
            return null;

        let monthString = NCB.DateUtils.getMonthName(this.props.date.getUTCMonth());
        let dayIndex = this.props.date.getUTCDay();
        if (dayIndex === 0)
            dayIndex = 6
        else
            dayIndex--;
             
        let dayString = NCB.DateUtils.getWeekDayName(dayIndex);
        let placeholder = this.props.isCheckout ? NCB.I18n.T.CHECK_OUT : NCB.I18n.T.CHECK_IN;
        let displayDate = this.state.isDirty ? NCB.DateUtils.getISODate(this.props.date) : placeholder;

        return <div className="ncb-datepicker-day" data-is-toggled={this.props.isToggled} onClick={this.handleClick}>
            <span className="ncb-datepicker-day-label">{this.props.label}</span>
            <div className="ncb-datepicker-day-content">
                <span className="ncb-datepicker-day-weekday">{dayString}</span>
                <span className="ncb-datepicker-day-date">{this.props.date.getUTCDate()}</span>
                <span className="ncb-datepicker-day-month">{monthString}</span>
                {
                    this.props.showYear ? <span className="ncb-datepicker-day-year">{this.props.date.getUTCFullYear()}</span> : null 
                }
            </div>

            <div style={{display: "none"}} className="ncb-datepicker-day-simple-date">{displayDate}</div>
        </div>
    }
}




// WEBPACK FOOTER //
// ./src/components/datepicker/datepickerDay.tsx